import { useUserProfile } from "../../contexts/user/UserContext"
import { Navigate } from "react-router-dom";
import { UserRoleEnum } from "../interfaces/user-profile.interface";

const RoleGuard = ({ children, roles }: { children: JSX.Element, roles: UserRoleEnum[] }) => {
    const { user } = useUserProfile();

    if (user?.role && roles.includes(user?.role)) {
        return children;
    }

    return <Navigate to="/" replace />;
}

export default RoleGuard;